import React from 'react';
import style from './tutorials.css';
import Header from '../manager/components/header/Header';

/**
 *
 * @param quizType
 * @param handleOpenTemplateWizard
 * @returns {JSX.Element}
 * @constructor
 */
const Tutorials = ( { props: {  quizType,  handleOpenTemplateWizard } } ) => {
    return (
        <section className={ style.wrapper }>
            <Header quizType={ quizType } handleOpenTemplateWizard={ handleOpenTemplateWizard }/>
            <iframe id='prevEmbedFrame-1'
                    src={ 'https://millionmind.com/tutorials/' }>
                Loading..
            </iframe>
        </section>
    );
};

export default Tutorials;